import React from 'react';
import {
    UsagePricingDataTableContainer,
    UsagePricingDataContainer,
    UsagePricingTableFont,
} from 'src/common/components/orderDetails/detailsDataTable/DetailsDataTable.styled';
import Datatable from 'src/common/refactoredComponents/dataTable/DataTable.jsx';
import BundleTag from 'src/common/components/orderDetails/bundleTag/BundleTag';
import CfnLabel from 'src/common/components/orderDetails/bundleCards/CfnLabel';
import SerialNoLabel from 'src/common/components/orderDetails/bundleCards/SerialNoLabel';
import ItemDescriptionLabel from 'src/common/components/orderDetails/bundleCards/ItemDescriptionLabel';
import { useSelector } from 'react-redux';
import PricingContainer from 'src/common/components/orderDetails/bundleCards/PricingContainer';
import BundleLayout from 'src/common/components/orderDetails/bundleCards/BundleLayout';
import {
    bundleRowToggleFunction,
    bundleArrowFunction,
    hasWhiteSpace,
    logErrorToConsole,
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';

const BillingSummaryDataTable = ({
    data,
    keyValue,
    bundleSubGroup,
    rowExpand,
    updateRowExpandHandler,
    setItemHandler,
    isBundleTable,
    // orderType,
    itemDescWidth,
    unitPriceWidth,
    qtyPriceWidth,
    lotSerialWidth,
    isBundle
}) => {
    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const orderType = orderBasicDetails?.currentOrderType; 
    const { t } = useTranslation();
    let colData = [
        {
            field: 'cfn',
            header: t(
                'reportUsage.review.discrepancy.RowHeaderDesktop.itemDescription'
            ),
        },
        {
            field: 'serialNo',
            width: '10%',
            header: t('consignmentBilling.payment.reportPayment.lotSerials'),
        },
        {
            field: 'quantity',
            header: t('consignmentBilling.payment.reportPayment.qTY'),
            width: '10%',
        },

        {
            field: 'poNumber',
            header: t('consignmentReturn.submit.pO'),
            width: '12%',
        },
        {
            field: 'unitPrice',
            header: t('reportUsage.itemList.unitPrice'),
            width: '10%',
        },
        {
            field: 'extPrice',
            header: t('reportUsage.itemList.exitPrice'),
            width: '10%',
        },
    ];

    if (orderBasicDetails?.isFromOrderHistory) {
        colData = colData.filter(
            (column) =>
                column.field !== 'unitPrice' && column.field !== 'extPrice'
        );
    }

    colData = colData?.map((column) => {
        const extraProps = {
            bodyStyle: {},
        };
        switch (column.field) {
            case 'cfn':
                extraProps.headerStyle = {
                    padding:'0px 0px 0px 10px',
                    width: itemDescWidth ? itemDescWidth : '20%',
                    height: '42px',
                };
                extraProps.bodyStyle = {
                    width: itemDescWidth ? itemDescWidth : '20%',
                    padding:  isBundle ? '0px 0px 0px 5px' : '0px 0px 0px 10px',
                };
                extraProps.body = (rowData) => {
                    const isBundle =
                        rowData?.isBundleHeader && rowData.isBundleHeader
                            ? rowData.isBundleHeader
                            : false;
                    const isBundleItems =
                        rowData?.bundleItems && rowData.bundleItems.length > 0
                            ? true
                            : false;
                    return (
                        <>
                            <BundleLayout
                                isExpand={
                                    isBundle && isBundleItems
                                        ? bundleArrowFunction(
                                              rowData.key,
                                              rowExpand
                                          )
                                        : false
                                }
                                bundleClickHandler={() => {
                                    try {
                                    rowToggleHandler(rowData, 'key', rowExpand);
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                                }}
                                isBundle={isBundle && isBundleItems}
                            >
                                <UsagePricingDataContainer
                                    justifyContent="flex-start"
                                    flexDirection="column"
                                    alignItems="flex-start"
                                    height="100%"
                                    padding={orderType === 'KE' ? '19px 0' : ''}
                                >
                                    <UsagePricingDataContainer
                                        alignItems={'center'}
                                        justifyContent={'flex-start'}
                                        width={'100%'}
                                    >
                                        <CfnLabel
                                            cfnFontColor={isBundle && '#140F4B'}
                                            setItemHandler={setItemHandler}
                                            setDetailsData={rowData}
                                            cfn={rowData?.cfn && rowData.cfn}
                                            isShowSetItemDetails={
                                                !isBundle ? true : false
                                            }
                                            cursor={'pointer'}
                                            
                                    isBundle = {true}
                                        />
                                        {isBundle || isBundleItems ? (
                                            <BundleTag
                                                bundleFontOpacity={'0.92'}
                                                value={'Bundle'}
                                            />
                                        ) : null}
                                    </UsagePricingDataContainer>

                                    <ItemDescriptionLabel
                                        textOverflow="ellipsis"
                                        overflow="hidden"
                                        lineClamp="2"
                                        orient="vertical"
                                        lineHeight="18px"
                                        color="#3C3C3C"
                                        fontSize="12px"
                                        display="-webkit-box"
                                        marginContainer={'5px 0 0 5px'}
                                        description={
                                            rowData?.description &&
                                            rowData.description
                                        }
                                    />
                                </UsagePricingDataContainer>
                            </BundleLayout>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'serialNo':
                extraProps.headerStyle = {
                       padding: '0 0 0 28px',
                    width: lotSerialWidth ? lotSerialWidth : '12.5%',
                    height: '42px',
                    textAlign: 'left',
                };

                extraProps.bodyStyle = {
                    width: lotSerialWidth ? lotSerialWidth : '12.5%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <SerialNoLabel
                            serialNo={rowData?.serialNo && rowData.serialNo}
                            alignItemsContainer={'flex-start'}
                            justifyContentContiner={'flex-start'}
                            heightContainer={'100%'}
                            marginContainer={'0px'}
                            paddingContainer={'19px 0 0 24px'}
                            textAlign={'left'}
                            wordBreak={'break-all'}
                        />
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'quantity':
                extraProps.headerStyle = {
                    // padding: '0 0 0 2%',
                    width: qtyPriceWidth ? qtyPriceWidth : '14%',
                    height: '42px',
                    textAlign: 'center',
                };
                extraProps.bodyStyle = {
                    width: qtyPriceWidth ? qtyPriceWidth : '14%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="flex-start"
                                justifyContent="center"
                                height="100%"
                                padding={'19px 0'}
                            >
                                {rowData?.quantity && (
                                    <>
                                        <UsagePricingTableFont
                                            fontFamily={'AvenirNextWorld Demi'}
                                            color={'#202124'}
                                            fontSize={'13px'}
                                        >
                                            {orderType === 'KE'
                                                ? null
                                                : `${
                                                      rowData?.isUsed &&
                                                      rowData.isUsed
                                                          ? t(
                                                                'reportUsage.record.priceOverride.AccountOwnedList.index.used'
                                                            )
                                                          : t(
                                                                'reportUsage.record.priceOverride.AccountOwnedList.index.other'
                                                            )
                                                  }`}
                                        </UsagePricingTableFont>
                                        <UsagePricingTableFont
                                            lineHeight="23px"
                                            letterSpacing="-0.11px"
                                            margin={'0px 0px 0px 5px'}
                                        >
                                            {`${rowData.quantity} X ${rowData.uom}`}
                                        </UsagePricingTableFont>
                                    </>
                                )}
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'poNumber':
                extraProps.headerStyle = {
                    padding: '0 2%',
                    width: '15%',
                    height: '42px',
                    textAlign: 'left',
                };
                extraProps.bodyStyle = {
                    width: '15%',
                    padding: '0 2.2%'
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="flex-start"
                                justifyContent="flex-start"
                                height="100%"
                                padding={'19px 0px 19px 0'}
                            >
                                {!rowData?.isAccountOwned ? (
                                    <UsagePricingTableFont
                                        lineHeight="23px"
                                        letterSpacing="-0.11px"
                                        textAlign={'left'}
                                        wordBreak={
                                            rowData?.poNumber
                                                ? hasWhiteSpace(
                                                      rowData.poNumber
                                                  )
                                                    ? 'break-word'
                                                    : 'break-all'
                                                : 'break-all'
                                        }
                                    >
                                        {rowData?.poNumber && rowData.poNumber}
                                    </UsagePricingTableFont>
                                ) : (
                                    <UsagePricingTableFont
                                        lineHeight="23px"
                                        letterSpacing="-0.11px"
                                        textAlign={'center'}
                                        fontSize={'12px'}
                                    >
                                        {t('reportUsage.summary.accountOwned')}
                                    </UsagePricingTableFont>
                                )}
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'unitPrice':
                extraProps.headerStyle = {
                    padding: '2px 5px 2px 0px',
                    width: unitPriceWidth ? unitPriceWidth : '12.5%',
                    height: '42px',
                    textAlign: 'right',
                    letterSpacing: ' 0.3px',
                };
                extraProps.bodyStyle = {
                    width: unitPriceWidth ? unitPriceWidth : '12.5%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            {!rowData?.isAccountOwned ? (
                                <PricingContainer
                                    alignItemsContainer="left"
                                    paddingContainer={orderType === 'KE'? '20px 0px 0px 0px': 
                                        '20px 0px 0px 0px'}
                                    marginContainer={'0'}
                                    heightContainer={'100%'}
                                    price={rowData.unitPrice}
                                    subPrice={rowData.overridenUnitPrice}
                                />
                            ) : null}
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'extPrice':
                extraProps.headerStyle = {
                    padding: '2px 20px 2px 0px',
                    width: '20%',
                    height: '42px',
                    textAlign: 'right',
                    letterSpacing: ' 0.3px',
                };
                extraProps.bodyStyle = {
                    width: '20%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            {!rowData?.isAccountOwned ? (
                                <PricingContainer
                                    alignItemsContainer="flex-end"
                                    paddingContainer={'20px 14px 0 0'}
                                    marginContainer={'0'}
                                    heightContainer={'100%'}
                                    price={rowData.extPrice}
                                    subPrice={rowData.overridenExtPrice}
                                />
                            ) : null}
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });

    let subColData = [
        {
            field: 'cfn',
            width: '27%',
        },
        {
            field: 'serialNo',
            width: '10%',
        },
        {
            field: 'quantity',
            width: '10%',
        },

        {
            field: 'poNumber',
            width: '12%',
        },
        {
            field: 'unitPrice',
            width: '10%',
        },
        {
            field: 'extPrice',
            width: '10%',
        },
    ];

    if (orderBasicDetails?.isFromOrderHistory) {
        subColData = subColData.filter(
            (column) =>
                column.field !== 'unitPrice' && column.field !== 'extPrice'
        );
    }

    subColData = subColData?.map((column) => {
        const extraProps = {
            bodyStyle: {},
        };
        switch (column.field) {
            case 'cfn':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '32%',
                    padding: '0px 0px 0px 10px',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                justifyContent="flex-start"
                                flexDirection="column"
                                alignItems="flex-start"
                                height="100%"
                                margin={'15px 0 0 0'}
                            >
                                <CfnLabel
                                    setItemHandler={setItemHandler}
                                    setDetailsData={rowData}
                                    cfn={rowData?.cfn ? rowData.cfn : null}
                                    isShowSetItemDetails={true}
                                    cursor={'pointer'}
                                />

                                <ItemDescriptionLabel
                                    textOverflow="ellipsis"
                                    overflow="hidden"
                                    lineClamp="2"
                                    orient="vertical"
                                    lineHeight="18px"
                                    color="#3C3C3C"
                                    fontSize="12px"
                                    display="-webkit-box"
                                    marginContainer={'5px 0 0 0'}
                                    description={
                                        rowData?.description &&
                                        rowData.description
                                    }
                                />
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'serialNo':
                extraProps.headerStyle = {
                    display: 'none',
                };

                extraProps.bodyStyle = {
                    width: '14%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <SerialNoLabel
                            serialNo={rowData?.serialNo && rowData.serialNo}
                            alignItemsContainer={'flex-start'}
                            justifyContentContiner={'flex-start'}
                            heightContainer={'100%'}
                            marginContainer={'0px'}
                            paddingContainer={'10px 0 0 0'}
                        />
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'quantity':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '15%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="flex-start"
                                justifyContent="center"
                                height="100%"
                                padding={'15px 0 0 0'}
                            >
                                {rowData?.quantity && (
                                    <>
                                        <UsagePricingTableFont
                                            fontFamily={'AvenirNextWorld Demi'}
                                            color={'#202124'}
                                        >
                                            {`${
                                                rowData?.isUsed &&
                                                rowData.isUsed
                                                    ? t(
                                                          'reportUsage.record.priceOverride.AccountOwnedList.index.used'
                                                      )
                                                    : t(
                                                          'reportUsage.record.priceOverride.AccountOwnedList.index.other'
                                                      )
                                            }`}
                                        </UsagePricingTableFont>
                                        <UsagePricingTableFont
                                            lineHeight="23px"
                                            letterSpacing="-0.11px"
                                            margin={'0px 0px 0px 5px'}
                                        >
                                            {`${rowData.quantity} X ${
                                                rowData.uom
                                                    ? rowData.uom
                                                    : t(
                                                          'orders.shipTrackLabels.eaLabel'
                                                      )
                                            }`}
                                        </UsagePricingTableFont>
                                    </>
                                )}
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'poNumber':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '16%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="flex-start"
                                justifyContent="center"
                                height="100%"
                                padding={'15px 0 0 0'}
                            >
                                <UsagePricingTableFont
                                    lineHeight="23px"
                                    letterSpacing="-0.11px"
                                    textAlign={'center'}
                                >
                                    {rowData?.poNumber && rowData.poNumber}
                                </UsagePricingTableFont>
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'unitPrice':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '12%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <PricingContainer
                                alignItemsContainer="flex-start"
                                paddingContainer={'10px 0 0 0'}
                                marginContainer={'0'}
                                heightContainer={'100%'}
                                price={rowData.unitPrice}
                                subPrice={rowData.overridenUnitPrice}
                            />
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'extPrice':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '11%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <PricingContainer
                                alignItemsContainer="flex-start"
                                paddingContainer={'10px 0 0 0'}
                                marginContainer={'0'}
                                heightContainer={'100%'}
                                price={rowData.extPrice}
                                subPrice={rowData.overridenExtPrice}
                            />
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });
    const rowToggleHandler = (e, key, expandRow) => {
        const updateExpandrow = bundleRowToggleFunction(e, key, expandRow);
        updateRowExpandHandler(updateExpandrow);
    };
    return (
        <UsagePricingDataTableContainer>
            <Datatable
                id={'orderDetails-details-billingsummary-datatable'}
                backgroundColorOdd={'#F5F5F599'}
                backgroundColorEven={'#FFFFFF99'}
                resizableColumns
                columns={colData}
                data={data}
                subColDatas={subColData}
                showSubTable={isBundleTable}
                keyValue={keyValue}
                bundleSubGroup={bundleSubGroup}
                expandRow={rowExpand}
                rowToggleHandler={rowToggleHandler}
                subTableWidth={'92%'}
                rows={data?.length > 0 ? data.length : 0}
            />
        </UsagePricingDataTableContainer>
    );
};

export default BillingSummaryDataTable;
